/**
 * changement-adresse-accesd
 *
 * Contact: DPSL_UNICODES@desjardins.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Adresse en format poste Canada
 */
export interface AdresseModification {
  /**
   * Le numero civique et nom de rue de l\'adresse.
   */
  numeroCiviqueNomRue: string;
  /**
   * Le numero de l\'unite. La longueur maximale est :  - 8 si typeUnite est APP  - 8 si typeUnite est APT  - 5 si typeUnite est BUREAU  - 6 si typeUnite est SUITE  - 6 si typeUnite est UNITE  - 7 si typeUnite est UNIT
   */
  numeroUnite?: string;
  /**
   * Type d\'unite de l\'adresse :  - APP : Appartement  - APT : Apartment  - BUREAU : Bureau  - SUITE : Suite  - UNITE : Unité  - UNIT : Unit.
   */
  typeUnite?: AdresseModificationTypeUniteEnum | null;
  /**
   * Le code postal de l\'adresse du membre. Format : X9X9X9 Il est obligatoire si l’adresse est canadienne.
   */
  codePostal: string;
  /**
   * Le code province/etat du pays. Pour le Canada, le code (ISO 3166-2) des provinces/territoires sont (obligatoire) :  - AB : Alberta  - BC : Colombie-Britannique  - MB : Manitoba  - NB : Nouveau-Brunswick  - NL : Terre-Neuve-et-Labrador  - NS : Nouvelle-Écosse  - NT : Territoires du Nord-Ouest  - NU : Nunavut  - ON : Ontario  - PE : Île-du-Prince-Édouard  - QC : Québec  - SK : Saskatchewan  - YT : Yukon
   */
  codeSubdivisionPays: AdresseModificationCodeSubdivisionPaysEnum | null;
  /**
   * Le nom de la municipalite est obligatoire si l\'adresse est canadienne.
   */
  nomMunicipalite: string;
}
export enum AdresseModificationTypeUniteEnum {
  APP = 'APP',
  APT = 'APT',
  BUREAU = 'BUREAU',
  SUITE = 'SUITE',
  UNITE = 'UNITE',
  UNIT = 'UNIT',
}
export enum AdresseModificationCodeSubdivisionPaysEnum {
  AB = 'AB',
  BC = 'BC',
  PE = 'PE',
  MB = 'MB',
  NB = 'NB',
  NS = 'NS',
  NU = 'NU',
  ON = 'ON',
  QC = 'QC',
  SK = 'SK',
  NL = 'NL',
  NT = 'NT',
  YT = 'YT',
}
